module.exports = __webpack_public_path__ + "static/media/iconCantineF.1c0bded4.svg";